/**
 * Разметка боксов детектора на отменённых фото (AI191, Алексей 29.09).
 *
 * Очередь живая: отменённые валидатором алерты YOLO-стеллажей за N дней, ещё не
 * размеченные. Координаты боксов и полок — доли 0–1 кропа стеллажа (`image_url`),
 * ровно того, что видел детектор; правка на полке = правка на стеллаже, переносить
 * ничего не надо.
 */
import { axiosInstance } from './api';

export type BoxView = 'queue' | 'modified' | 'correct';
export const BOX_VIEWS: BoxView[] = ['queue', 'modified', 'correct'];

export interface Box {
  /** id строки cctv_core_boundingbox; null у дорисованных. */
  id: number | null;
  x0: number; y0: number; x1: number; y1: number;
  score: number;
  /** Ниже порога детектора — в подсчёт не шёл, показывается по флажку. */
  weak: boolean;
  deleted: boolean;
  added: boolean;
}

export interface BoxShelf {
  id: number; name: string; num: number;
  /** Четырёхугольник полки в долях кропа стеллажа; null, если геометрия не сошлась. */
  poly: number[][] | null;
  pct: number | null;
  threshold: number;
  empty: boolean;
}

export interface BoxItem {
  key: string;
  validation_id: number | null;
  zone_id: number | null; zone: string | null;
  camera_id: number; camera: string;
  rack_id: number; rack: string;
  frame_id: number;
  ts: string | null;
  image_url: string | null;
  predicted_status: string | null;
  validated_status: string | null;
  threshold: number;
  shelves: BoxShelf[];
  boxes: Box[];
  label: { status: 'modified' | 'correct'; annotated_by: string | null; annotated_at: string } | null;
}

export interface BoxZone { zone_id: number; zone: string | null; queue: number; modified: number; correct: number }

export interface BoxZonesResponse {
  zones: BoxZone[]; days: number;
  totals: { queue: number; modified: number; correct: number };
}

export interface BoxSamples {
  items: BoxItem[];
  facets: { queue: number; modified: number; correct: number };
  view: BoxView; days: number; total: number; page: number; page_size: number;
}

export const getBoxPoolZones = (days: number) =>
  axiosInstance.get<BoxZonesResponse>('/ml_models_lifecycle/box/pool/zones/', { params: { days } });

export const getBoxPoolSamples = (params: {
  zone_id: number | null; view: BoxView; days: number; page: number; page_size: number;
}) =>
  axiosInstance.get<BoxSamples>('/ml_models_lifecycle/box/pool/samples/', {
    params: {
      ...(params.zone_id ? { zone_id: params.zone_id } : {}),
      view: params.view, days: params.days, page: params.page, page_size: params.page_size,
    },
  });

/** status null — снять разметку, фото вернётся в очередь. */
export type BoxLabelDelta = {
  validation_id: number; status: 'modified' | 'correct' | null; boxes?: Box[];
};

export const boxPoolAnnotate = (items: BoxLabelDelta[]) =>
  axiosInstance.post<{ saved: number; removed: number }>(
    '/ml_models_lifecycle/box/pool/annotate/', { items });
